<template>
  <div class="menu-container">
    <global-layout>
      <contextmenu :itemList="menuItemList" :visible.sync="menuVisible" @select="onMenuSelect" />
      <transition name="page-toggle">
        <keep-alive v-if="multipage" :exclude="indexLists">
          <router-view />
        </keep-alive>
        <router-view v-else />
      </transition>
    </global-layout>
  </div>
</template>
<script>
import GlobalLayout from '@/layouts/GlobalLayout'
import Contextmenu from '@/components/menu/Contextmenu'
import request from '@/utils/request_zcm'
export default {
  name: 'MenuViewMoneyCat',
  components: { Contextmenu, GlobalLayout },
  data() {
    return {
      pageList: [],
      linkList: [],
      menuVisible: false,
      cancel: false,
      menuItemList: [
        { key: '1', icon: 'arrow-left', text: '关闭左侧' },
        { key: '2', icon: 'arrow-right', text: '关闭右侧' },
        { key: '3', icon: 'close', text: '关闭其它' },
      ],
    }
  },
  computed: {
    indexLists() {
      return this.$store.state.setting.indexLists
    },
    multipage() {
      return this.$store.state.setting.multipage
    },
  },
  created() {
    this.pageList.push(this.$route)
    this.linkList.push(this.$route.fullPath)
  },
  watch: {
    $route: function (newRoute, oldRoute) {
      if (!this.multipage) {
        this.linkList = [newRoute.fullPath]
        this.pageList = [newRoute]
      } else if (this.linkList.indexOf(newRoute.fullPath) < 0) {
        this.linkList.push(newRoute.fullPath)
        this.pageList.push(newRoute)
      }
      if (newRoute.name == '自助开票' && oldRoute.name == '开始开票(自助开票)') {
        this.remove('/zcm/board/Start_booking')
      }
    },
    multipage: function (newVal, oldVal) {
      if (!newVal) {
        this.linkList = [this.$route.fullPath]
        this.pageList = [this.$route]
      }
    },
  },
  methods: {
    remove(key) {
      if (this.pageList.length === 1) {
        return
      }
      if (key == '/zcm/board/Start_booking') {
        this.Cancel()
      } else if (key == '/zcm/board/Planning_invoicing_plan') {
        this.$store.state.Planning_name = true
      }
      this.pageList = this.pageList.filter(item => item.fullPath !== key)
      let index = this.linkList.indexOf(key)
      this.linkList = this.linkList.filter(item => item !== key)
      index = index >= this.linkList.length ? this.linkList.length - 1 : index
    },
    // 开票关闭时调用
    Cancel() {
      var params = JSON.stringify(this.$store.state.invoiceNumbering)
      request({
        method: 'POST',
        url: '/invoicing/close',
        data: {
          tids: params,
        },
      })
        .then(res => {
          if (res.code != '2112') {
            this.$message.error('暂无该单号对应数据，请检查单号是否有误！')
          }
        })
        .catch(error => {
          this.$message.error(error.response.data.message)
        })
    },
    /**
     * 由于ant-design-vue组件库的TabPane组件暂不支持自定义监听器，无法直接获取到右键target所在标签页的 pagekey 。故增加此方法用于
     * 查询右键target所在标签页的标识 pagekey ，以用于自定义右键菜单的事件处理。
     * 注：TabPane组件支持自定义监听器后可去除该方法并重构 ‘自定义右键菜单的事件处理’
     * @param target 查询开始目标
     * @param count 查询层级深度 （查找层级最多不超过3层，超过3层深度直接返回 null）
     * @returns {String}
     */
    getPageKey(target, depth) {
      depth = depth || 0
      if (depth > 2) {
        return null
      }
      let pageKey = target.getAttribute('pagekey')
      pageKey =
        pageKey ||
        (target.previousElementSibling
          ? target.previousElementSibling.getAttribute('pagekey')
          : null)
      return (
        pageKey ||
        (target.firstElementChild ? this.getPageKey(target.firstElementChild, ++depth) : null)
      )
    },
    onMenuSelect(key, target) {
      let pageKey = this.getPageKey(target)
      switch (key) {
        case '1':
          this.closeLeft(pageKey)
          break
        case '2':
          this.closeRight(pageKey)
          break
        case '3':
          this.closeOthers(pageKey)
          break
        default:
          break
      }
    },
    closeOthers(pageKey) {
      let index = this.linkList.indexOf(pageKey)
      this.linkList = this.linkList.slice(index, index + 1)
      this.pageList = this.pageList.slice(index, index + 1)
    },
    closeLeft(pageKey) {
      let index = this.linkList.indexOf(pageKey)
      this.linkList = this.linkList.slice(index)
      this.pageList = this.pageList.slice(index)
    },
    closeRight(pageKey) {
      let index = this.linkList.indexOf(pageKey)
      this.linkList = this.linkList.slice(0, index + 1)
      this.pageList = this.pageList.slice(0, index + 1)
    },
  },
}
</script>

<style scoped>
.menu-container >>> .ant-tabs-bar {
  margin-bottom: 0px;
}
.menu-container >>> .ant-menu-item-selected > a {
  color: red;
  background-color: pink;
}
.menu-container >>> .ant-menu-item .ant-menu-item-selected {
  background-color: red;
}
.menu-container >>> .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background: #f6f6f6;
  color: red;
}
.menu-container >>> .ant-menu-item > a:hover {
  color: red;
}
.menu-container >>> .ant-menu-submenu-title:hover {
  color: red;
}
.menu-container >>> .ant-menu-item-selected .anticon svg path {
  fill: red !important;
}
.menu-container >>> .ant-menu-inline .ant-menu-item:after {
  content: '';
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  border-right: 3px solid red;
}
</style>




// WEBPACK FOOTER //
// src/layouts/MenuView.vue